<template>
  <tbody>
    <tr class="returnable-order">
      <td class="order-number">
        <a :href="order.order_path">
          {{ order.number }}
        </a>
      </td>
      <td class="order-date">{{ order.completed_at }}</td>
      <td class="order-status">{{ order.state }}</td>
      <td class="order-payment-state">{{ order.payment_state }}</td>
      <td class="order-shipment-state">{{ order.shipment_state }}</td>
      <td class="lead text-primary order-total">{{ order.display_total }}</td>
      <td class="order-action text-nowrap">
        <button
          v-if="order.shipments.length > 1"
          class="text-uppercase btn btn-warning show-shipments-btn"
          :disabled="showWhichShipments"
          @click="onClickWhichShipment"
        >
          <template v-if="showWhichShipments">
            Select a Shipment
          </template>
          <template v-else>
            Submit a return
          </template>
        </button>
        <a
          v-else
          :href="order.shipments[0].new_reimbursement_request_path"
          class="text-uppercase btn btn-warning new-request-btn"
        >
          Submit a return
        </a>
      </td>
    </tr>
    <template v-if="showWhichShipments">
      <tr>
        <td
          colspan="7"
          class="which-shipment-title"
        >
          Which shipment would you like to return?
        </td>
      </tr>
      <tr
        v-for="shipment in order.shipments"
        :key="shipment.number"
        class="shipment-to-return"
      >
        <td colspan="6">
          <h4 class="shipment-number">
            Shipment Number {{ shipment.number }} from {{ shipment.stock_location }}
          </h4>
          <ul class="items">
            <li
              v-for="item in shipment.items"
              :key="item.line_item_id"
              class="shipment-item"
            >
              {{ item.name }}, Quantity: {{ item.quantity }}
            </li>
          </ul>
        </td>
        <td>
          <a
            :href="shipment.new_reimbursement_request_path"
            class="text-uppercase btn btn-warning new-request-btn"
          >
            Submit A Return
          </a>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
  export default {
    props: {
      order: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        showWhichShipments: false
      }
    },
    methods: {
      onClickWhichShipment() {
        this.showWhichShipments = true;
      },
    },
  };
</script>
